/**
 * DocStepList
 *
 * Numbered step walkthrough. Each step has a violet circular badge with the
 * step number, a bold title, and a short description.
 */
import type { ReactNode } from 'react';
import { cn } from '@respectly/ui';

export interface DocStep {
  title: string;
  description: ReactNode;
}

export interface DocStepListProps {
  steps: DocStep[];
  startAt?: number;
  className?: string;
}

export function DocStepList({ steps, startAt = 1, className }: DocStepListProps) {
  return (
    <ol className={cn('space-y-4 my-4', className)}>
      {steps.map((step, index) => (
        <li key={index} className="flex gap-4">
          <div className="flex-shrink-0 w-8 h-8 rounded-full bg-violet-100 dark:bg-violet-900/40 text-violet-700 dark:text-violet-300 font-semibold text-sm flex items-center justify-center">
            {startAt + index}
          </div>
          <div className="flex-1 min-w-0 pt-0.5">
            <p className="font-semibold text-slate-900 dark:text-white">
              {step.title}
            </p>
            <div className="mt-1 text-sm text-slate-600 dark:text-slate-400 leading-6">
              {step.description}
            </div>
          </div>
        </li>
      ))}
    </ol>
  );
}
